import { Button } from "@/components/ui/button";
import { useLegalTranslation } from "@/hooks";

interface CookieBannerProps {
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onConfigure: () => void;
}

export function CookieBanner({ onAcceptAll, onRejectAll, onConfigure }: CookieBannerProps) {
  const { t } = useLegalTranslation();

  return (
    <section
      className="fixed inset-x-0 bottom-0 z-[70] border-t border-gray-200 bg-white p-4 shadow-2xl"
      aria-label={t("cookieBanner.ariaLabel")}
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="space-y-2">
          <h2 className="text-base font-semibold text-gray-900">{t("cookieBanner.title")}</h2>
          <p className="text-sm text-gray-700">{t("cookieBanner.description")}</p>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row">
          <Button type="button" variant="outline" onClick={onConfigure}>
            {t("cookieBanner.configureButton")}
          </Button>
          <Button type="button" variant="outline" onClick={onRejectAll}>
            {t("cookieBanner.rejectButton")}
          </Button>
          <Button type="button" onClick={onAcceptAll}>
            {t("cookieBanner.acceptAllButton")}
          </Button>
        </div>
      </div>
    </section>
  );
}
